/**
 * Created by lihanying on 2017/7/6.
 */
import { API_DOMAIN } from '../../config'
import 'whatwg-fetch'
import { fetchData, postData } from '../../util/index'
import { message } from 'antd'
import {
  GETPERMISSION,
  GETCLUBLISTSUCCESS,
  GETCLUBINFO,
  GETWALLETINFO,
  GETWALLETRECORD,
} from './constants'

export const getPermission = (payload) => {
  return {
    type: GETPERMISSION,
    payload,
  }
}

export const getClubListSuccess = (payload) => {
  return {
    type: GETCLUBLISTSUCCESS,
    payload,
  }
}
export const getClubInfo = (payload) => {
  return {
    type: GETCLUBINFO,
    payload,
  }
}
export const getWalletInfo = (payload) => {
  return {
    type: GETWALLETINFO,
    payload,
  }
}
export const getWalletRecord = (payload) => {
  return {
    type: GETWALLETRECORD,
    payload,
  }
}

//俱乐部
export function fetchClubList(count = '0') {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Manage/ClubApi/ClubList/p/${count}`
    return fetchData(endpoint).then((data) => {
      if (data === '0004') {
        message.error(data.detail)
        dispatch(getPermission('permission'))
      } else {
        dispatch(getClubListSuccess(data.list))
      }
    })
  }
}

//搜索
export function searchData(keyword = false) {
  return (dispatch, getState) => {
    const data = getState().getClubList.clubList
    let searchResult = []
    if (data && keyword !== false) {
      searchResult = data.filter(
        (item) =>
          item.club_name.indexOf(keyword) !== -1 ||
          item.official_person.indexOf(keyword) !== -1
      )
    }
    dispatch(getClubListSuccess(searchResult))
  }
}

//删除俱乐部
export function fetchDeleteClub(club_id) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Manage/ClubApi/DelClub/id/${club_id}`
    return fetchData(endpoint).then((data) => {
      if (data.status === true) {
        message.success(data.detail)
        dispatch(fetchClubList())
      } else {
        message.error(data.detail)
      }
    })
  }
}

export function fetchClubInfo(club_id) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Manage/ClubApi/EditClub/id/${club_id}`
    return fetchData(endpoint).then((data) => {
      dispatch(getClubInfo(data.info))
      return data
    })
  }
}

//修改
export function fetchEditClub(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Manage/ClubApi/EditClub`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      if (data.status === true) {
        message.success(data.detail)
        dispatch(fetchClubList())
      } else {
        message.error(data.detail)
      }
    })
  }
}

//俱乐部钱包
export function fetchWalletInfo(club_id) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Manage/ClubApi/getWalletInfo/club_id/${club_id}`
    return fetchData(endpoint).then((data) => {
      dispatch(getWalletInfo(data.list))
    })
  }
}
//钱包消费流水
export function fetchWalletRecord(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Manage/WalletApi/WalletClub`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      dispatch(getWalletRecord(data))
      return data
    })
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubList/action.js